var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "X_icon",
    transform: "translate(-0.254 -0.133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143856",
    "data-name": "Path 143856",
    d: "M14.535.223A16.017,16.017,0,0,0,.9,20.66,16,16,0,1,0,19.991.6,15.687,15.687,0,0,0,14.535.223Zm.214,9.935c1.369,1.818,2.525,3.315,2.567,3.315s1.466-1.5,3.145-3.315l3.07-3.315h1.744l-.374.4c-.214.224-1.6,1.732-3.092,3.347s-2.942,3.186-3.231,3.476l-.513.545,4.012,5.336c2.2,2.941,4.012,5.379,4.012,5.422a23.507,23.507,0,0,1-2.91.085l-2.92-.011L17.541,21.8c-1.872-2.513-2.749-3.594-2.835-3.529-.064.053-1.584,1.69-3.38,3.636l-3.263,3.54H7.238A3.192,3.192,0,0,1,6.4,25.4c0-.032,1.7-1.893,3.776-4.128s3.777-4.107,3.8-4.138-1.69-2.364-3.776-5.155S6.4,6.9,6.4,6.874s1.315-.032,2.931-.032h2.931Zm0,0",
    transform: "translate(0 0)",
    fill: "#92a7ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143857",
    "data-name": "Path 143857",
    d: "M41.3,37.65c.043.075,2.738,3.69,5.969,8.01l5.884,7.871,1.315.011c.813,0,1.306-.043,1.284-.107s-2.7-3.668-5.947-8.021L43.882,37.5H42.555c-1.1,0-1.326.022-1.251.15Zm0,0",
    transform: "translate(-32.257 -29.374)",
    fill: "#92a7ba"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.8656e808ca892125281ccde5517ac988.svg";
export { ForwardRef as ReactComponent };